function toggleMobileSearch () {
  if (window.widgetTimeout) {
    clearTimeout(window.widgetTimeout)
    window.widgetTimeout = null
  }

  const $ms = $('.mobile-search')
  $ms.toggleClass('open')
}

function initMobileSearch () {
  $('.widget-search-button').click(toggleMobileSearch)
}

$(document).on('pjax:end', initMobileSearch)
initMobileSearch()
